import React from 'react';
import AppPanicLog from './components';
import Layout from '../../layouts/index';

const PanicLog = () => {
    return (
        <Layout>
            <AppPanicLog />
        </Layout>
    );
};

export default PanicLog;
